import React from 'react'
import styles from "./page.module.css";

const DEFAULT_CLASSES = {
  container: styles.pageContainer,
  content: styles.pageContent,
  contentSkinny: styles.skinny,
  title: styles.pageTitle
};

export default function Page({ 
    children, 
    title,
    skinny=false,
    pageClassesOverride = {},
    pageStyles = {}
  }) {

  const classes = { ...DEFAULT_CLASSES, ...pageClassesOverride };
  const contentClassName = [classes.content, skinny ? classes.contentSkinny : null]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes.container} style={pageStyles.container}>
      <div className={contentClassName} style={pageStyles.content}>
        {title && <h1 className={classes.title} style={pageStyles.title}>{title}</h1>}
        {children}
      </div>

    </div>
  )
}
